import { Component, Input } from '@angular/core';

@Component({
  selector: 'unicon-chart-top-legend',
  templateUrl: './chart-top-legend.component.html',
})
export class ChartTopLegendComponent {
  @Input() amount?: number;
  @Input() statusName?: string;
  @Input() percent?: number;
  @Input() positive: boolean = true;
}
